import React, { useState } from "react";
import { BiDollar } from "react-icons/bi";
import { FaUsers } from "react-icons/fa";
import PurchaseDashboard from "./PurchaseDashboard";
import UserDashboard from "./UserDashboard";

const MainDashboard = () => {
  const [activeTab, setActiveTab] = useState("purchase");

  return (
    <div className="w-full md:ml-[4.4rem] px-4 md:px-8 lg:px-10 mt-20 bg-main-bg min-h-screen pb-12">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500;600&display=swap');
        * { font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif; }
        .mono { font-family: 'JetBrains Mono', monospace; }
        .stat-card { background: linear-gradient(135deg, #2563EB 0%, #1d4ed8 100%); position: relative; overflow: hidden; }
        .stat-card-success { background: linear-gradient(135deg, #10B981 0%, #059669 100%); }
        .stat-card-organic { background: linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%); }
        .stat-card-pid { background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%); }
        .stat-card-revenue { background: linear-gradient(135deg, #EC4899 0%, #DB2777 100%); }
        .hover-lift:hover { transform: translateY(-2px); }
        .animate-spin { animation: spin 1s linear infinite; }
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        .download-menu {
          position: absolute; top: calc(100% + 8px); right: 0;
          background: white; border-radius: 16px;
          box-shadow: 0 20px 60px rgba(0,0,0,0.15);
          border: 1px solid #e5e7eb; z-index: 50; min-width: 200px; overflow: hidden;
        }
        .download-menu-item {
          display: flex; align-items: center; gap: 12px;
          padding: 14px 20px; cursor: pointer; font-weight: 600;
          font-size: 15px; transition: background 0.15s;
        }
        .download-menu-item:hover { background: #f1f5f9; }
        .download-menu-item.pdf { color: #dc2626; }
        .download-menu-item.excel { color: #16a34a; }
        .download-menu-item + .download-menu-item { border-top: 1px solid #f1f5f9; }
      `}</style>

      {/* TAB BAR */}
      <div className="flex gap-3 mb-8 mt-2">
        <button
          onClick={() => setActiveTab("purchase")}
          className={`flex items-center gap-3 px-8 py-4 rounded-2xl font-bold text-lg transition-all duration-300 ${activeTab === "purchase"
            ? "bg-main-blue text-main-white shadow-xl"
            : "bg-main-white text-main-subfont hover:text-main-font border-2 border-main-border hover:border-main-blue"
            }`}
        >
          <BiDollar className="text-2xl" />
          Purchase Dashboard
        </button>
        <button
          onClick={() => setActiveTab("user")}
          className={`flex items-center gap-3 px-8 py-4 rounded-2xl font-bold text-lg transition-all duration-300 ${activeTab === "user"
            ? "bg-main-blue text-main-white shadow-xl"
            : "bg-main-white text-main-subfont hover:text-main-font border-2 border-main-border hover:border-main-blue"
            }`}
        >
          <FaUsers className="text-2xl" />
          User Dashboard
        </button>
      </div>

      {activeTab === "purchase" && <PurchaseDashboard />}
      {activeTab === "user" && <UserDashboard />}
    </div>
  );
};

export default MainDashboard;



